import { render, staticRenderFns } from "./QBVideoList.vue?vue&type=template&id=2213fa0b"
import script from "./QBVideoList.vue?vue&type=script&lang=js"
export * from "./QBVideoList.vue?vue&type=script&lang=js"
import style0 from "./QBVideoList.vue?vue&type=style&index=0&id=2213fa0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports